@let stage = store.stageSg();

@if (stage) {
  <atn-ds-centered-overlay type="full-width">
    <atn-ds-widget
      class="atn-quiver-deployment-modal"
      [title]="'New Quiver Deployment — ' + store.stageNameSg()"
    >
      <div class="atn-quiver-deployment-modal__body">
        <atn-quiver-deployment-modal-body />
      </div>
      <div class="atn-quiver-deployment-modal__notice">
        <atn-ds-notice
          [style]="DisplayStyle.Warning"
          description="Before continuing, please ensure you have the required DMS and Mosaic permissions."
        />
      </div>
      <atn-quiver-deployment-modal-footer
        footer
        class="atn-quiver-deployment-modal__footer"
      />
    </atn-ds-widget>
  </atn-ds-centered-overlay>
}
